import HomePage from "./components/HomePage";
import StateContextP from "./context/StateContextP";
import Footer from './components/Footer';

function App() {
  return (
    <div>
      <StateContextP>
        <HomePage />
        <Footer />
      </StateContextP>
    </div>
  );
}

export default App;
